const DEFAULT_WINDOW_MS = 10_000

/**
 * Drop duplicate realtime messages by ``ulid`` within a sliding time window.
 */
export class UlidDedupe {
  private readonly windowMs: number
  private readonly seen = new Map<string, number>()

  constructor(windowMs: number = DEFAULT_WINDOW_MS) {
    this.windowMs = windowMs
  }

  isDuplicate(ulid: string | undefined): boolean {
    if (!ulid) return false
    const now = Date.now()
    this.prune(now)
    const prev = this.seen.get(ulid)
    if (prev !== undefined && now - prev < this.windowMs) {
      return true
    }
    this.seen.set(ulid, now)
    return false
  }

  clear(): void {
    this.seen.clear()
  }

  private prune(now: number): void {
    for (const [id, ts] of this.seen.entries()) {
      if (now - ts >= this.windowMs) {
        this.seen.delete(id)
      }
    }
  }
}
